















































































import {Component, Vue} from 'vue-property-decorator'
import HeaderBar from '@/components/HeaderBar.vue'
import MenusStore from "@/store/modules/MenusStore";
import OptionSelector from "@/components/OptionSelector/OptionSelector.vue";
import AddMenuDialog from "@/components/Dialog/AddMenuDialog.vue";
import EditMenuDialog from "@/components/Dialog/EditMenuDialog.vue";
import DeleteMenuDialog from "@/components/Dialog/DeleteMenuDialog.vue";
import CopyMenuDialog from "@/components/Dialog/CopyMenuDialog.vue";
import MenuOptionSelector from "@/components/OptionSelector/MenuOptionSelector.vue";
import MenuListSorter from "@/components/ListSorter/MenuListSorter.vue";
import Background from '@/components/Background.vue'
import SchedulesStore from '@/store/modules/SchedulesStore'
import CategoriesStore from '@/_common/api/store/modules/CategoriesStore'
import CategoryItemsStore from '@/_common/api/store/modules/CategoryItemsStore'
import ThemeVariableStore from '@/store/modules/ThemeVariableStore'
import ThemeCategoryVariablesStore from '@/store/modules/ThemeCategoryVariablesStore'
import { Util } from '@/_global/utils'

@Component({
    components: {
        MenuListSorter,
        HeaderBar,
        AddMenuDialog,
        OptionSelector,
        EditMenuDialog,
        MenuOptionSelector,
        DeleteMenuDialog,
        CopyMenuDialog,
        Background,
    },
})
export default class MenuListPage extends Vue {
    private initialized: boolean = false;
    private isAddingMenu = false;
    private editingMenuId = -1;
    private deletingMenuId = -1;
    private copyMenuId = -1;

    async created() {
        this.initialized = false;
        await MenusStore.init();
        this.initialized = true;
    }

    get editingMenu(): CMS.Menu {
        return MenusStore.menuById[this.editingMenuId];
    }

    get deletingMenu(): CMS.Menu {
        return MenusStore.menuById[this.deletingMenuId];
    }

    get menuLength() {
        return MenusStore.all.length;
    }

    // ソート
    private onChangeSort(sortedIds: number[]): void {
        MenusStore.localSort(sortedIds);
    }

    private onEndSort(): void {
        MenusStore.applySort();
    }

    // 追加
    private onClickAddMenu(): void {
        this.isAddingMenu = true;
    }

    private onCancelAddMenu(): void {
        this.isAddingMenu = false;
    }

    private onOkAddMenu(menu: CMS.Menu) {
        MenusStore.create(menu);
        this.isAddingMenu = false;
    }

    // 編集
    private onSelectEdit(menuId: number): void {
        this.editingMenuId = menuId;
    }

    private onCancelEditMenu(): void {
        this.editingMenuId = -1;
    }

    private onOkEditMenu(menu: CMS.Menu): void {
        MenusStore.edit(menu);
        this.editingMenuId = -1;
    }

    // 削除
    private onSelectDelete(menuId: number): void {
        this.deletingMenuId = menuId;
    }

    private onCancelDeleteMenu(): void {
        this.deletingMenuId = -1;
    }

    private onOkDeleteMenu(): void {
        MenusStore.delete(this.deletingMenuId);
        this.deletingMenuId = -1;
    }

    // コピー
    private onSelectCopy(menuId: number): void {
        this.copyMenuId = menuId;
    }

    private onCancelCopyMenu(): void {
        this.copyMenuId = -1;
    }

    private async onOkCopyMenu(menu: CMS.Menu) {
        try {
            // メニュー登録
            await MenusStore.create(menu);
            let lastMenu = MenusStore.all.slice(-1)[0];

            // 店舗 コピー
            lastMenu.store_ids = MenusStore.menuById[this.copyMenuId].store_ids
            await MenusStore.editMenuStores(lastMenu);

            // テーマ変数を初期化
            const themeId: number = MenusStore.menuById[this.copyMenuId].theme_id;
            await ThemeVariableStore.init({themeId: themeId, menuId: this.copyMenuId});
            await ThemeCategoryVariablesStore.init({themeId: themeId, menuId: this.copyMenuId});

            // スケジュール コピー
            await this.scheduleCopy(this.copyMenuId, lastMenu.id);
            // カテゴリー コピー
            await this.categoryCopy(this.copyMenuId, lastMenu.id);
            // テーマ別メニュー項目 コピー
            await ThemeVariableStore.copy(lastMenu.id);
        } catch(err) {
            console.log("menu copy error!!");
            console.error(err);
        }

        this.copyMenuId = -1;
    }

    private async scheduleCopy(originMenuId: number, newMenuId: number) {
        await SchedulesStore.init(originMenuId);
        let scheduleList :CMS.Schedule[] = SchedulesStore.all

        for (let i = 0; i < scheduleList.length; i++) {
            // id は、登録時に使用されていないため、上書きしない
            scheduleList[i].menu_id = newMenuId;
            await SchedulesStore.create(scheduleList[i]);
        }
    }

    private async categoryCopy(originMenuId: number, newMenuId: number) {
        await CategoriesStore.init(originMenuId);
        await CategoryItemsStore.init(originMenuId);
        let categoryList: CMS.Category[] = CategoriesStore.all
        for (let i = 0; i < categoryList.length; i++) {
            let originCategory: CMS.Category = categoryList[i];
            // id は、登録時に使用されていないため、上書きしない
            originCategory.menu_id = newMenuId;
            await CategoriesStore.create(originCategory);

            // id取得
            let lastCategory = CategoriesStore.all.slice(-1)[0];

            // カテゴリー内の商品　コピー
            const newItems: CMS.CategoryItem[] = Util.deepCopy(CategoryItemsStore.categoryItemsByCategoryId[originCategory.id] || []);
            if (newItems.length > 0) {
                newItems.map((item :CMS.CategoryItem) => {item.category_id = lastCategory.id;});
                await CategoryItemsStore.create(newItems);
            }

            // テーマ別カテゴリー項目 セット
            let originVariable: CMS.ThemeCategoryVariable = ThemeCategoryVariablesStore.variableByCategoryId[originCategory.id];
            if (originVariable) {
                let newVariable: CMS.ThemeCategoryVariable = Util.deepCopy(originVariable);
                newVariable.category_id = lastCategory.id
                ThemeCategoryVariablesStore.localAdd(newVariable);
            }

        }

        // テーマ別カテゴリー項目 コピー
        await ThemeCategoryVariablesStore.applyEdit();
    }

}
